import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import { listarPermisos, ValidarPermisos, LIST_SCREENS, ValidarUsuario, ObtenerUsuario, ObtenerDetalleToken } from '../../utils/utils'

import NavBar from '../../dashboard/navBar';
import TituloPagina from '../../dashboard/headerTitle';

// Material UI Elements
import { DataGrid, esES } from '@mui/x-data-grid';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ButtonMUI from '@mui/material/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@mui/material/Divider';
// Material Icons Elements
import PublishIcon from '@material-ui/icons/Publish';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

//ReactBootstral
import Stack from 'react-bootstrap/Stack';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

class configBasesAp_Detalle extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idproyecto: null,
            permisos: [],
            objmenu: null,
            mostrarModalCargarArchivos: false,
            columns: [
                {
                    field: 'acciones', headerName: 'Acciones', flex: 1, headerClassName: 'header-colum-table', renderCell: () => {
                        return (
                            <>
                                <Tooltip title="Cargar elemento">
                                    <IconButton onClick={() => {
                                    }}>
                                        <EditIcon fontSize='small' color='primary' />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Ver detalle">
                                    <IconButton onClick={() => {
                                    }}>
                                        <DeleteIcon fontSize='small' />
                                    </IconButton>
                                </Tooltip>
                            </>
                        );
                    }
                },
                { field: 'colum1', headerName: 'AAAAAAAAA', flex: 1, headerClassName: 'header-colum-table' },
                { field: 'colum2', headerName: 'BBBBBBBBB', flex: 1, headerClassName: 'header-colum-table' },
                { field: 'colum3', headerName: 'CCCCCCCCC', flex: 1, headerClassName: 'header-colum-table' },
                { field: 'colum4', headerName: 'DDDDDDDDD', flex: 1, headerClassName: 'header-colum-table' },
                { field: 'colum5', headerName: 'EEEEEEEEE', flex: 1, headerClassName: 'header-colum-table' },
                { field: 'colum6', headerName: 'FFFFFFFFF', flex: 1, headerClassName: 'header-colum-table' },
            ],
            rows: [
                { id: 1, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 2, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 3, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 4, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 5, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 6, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 7, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 8, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 9, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 10, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 11, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 12, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 13, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 14, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 15, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 16, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 17, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },
                { id: 18, colum1: '', colum1: 'AAAAAAAAA', colum2: 'BBBBBBBBB', colum3: 'CCCCCCCCC', colum4: 'DDDDDDDDD', colum5: 'EEEEEEEEE', colum6: 'FFFFFFFFF' },

            ]
        };
    }

    componentDidMount() {
        if (ValidarUsuario()) {
            listarPermisos().then(async (permisos) => {
                if (ValidarPermisos(LIST_SCREENS.ACCESS_SCREEN_CONFIG_BASES_AP, permisos)) {
                    let UsuarioStorage = ObtenerUsuario();
                    UsuarioStorage = JSON.parse(UsuarioStorage);
                    //Extraer el codigo de Proyecto
                    if (UsuarioStorage.token) {
                        let DetalleToken = JSON.parse(ObtenerDetalleToken(UsuarioStorage.token));
                        if (DetalleToken.idproyecto) {
                            await this.setState({ idproyecto: DetalleToken.idproyecto });
                        }
                    }
                    // Acciones Aqui

                }
                else {
                    this.setState({ abrirToast: true, mensajeToast: "No tiene permisos para acceder a este Recurso", tipotoast: 'warning' });
                    setTimeout(() => {
                        this.props.history.push('/configuracion');
                    }, 1000);
                }
            });
        }
        else {
            this.props.history.push('/login');
        }
    }
    //***************************************************** */
    // Modales
    //***************************************************** */
    AbrirModalSubirArchivo = () => {
        this.setState({ mostrarModalCargarArchivos: true });
    }
    CerrarModalSubirArchivo = () => {
        this.setState({ mostrarModalCargarArchivos: false });
    }
    //***************************************************** */
    //Acciones de Menu
    //***************************************************** */
    AbrirMenu = (event) => {
        this.setState({ objmenu: event.currentTarget })
        // setobjetoMenu(event.currentTarget);
    };

    CerrarMenu = () => {
        this.setState({ objmenu: null })
    };

    render() {
        return (
            <Fragment>
                <NavBar />
                <TituloPagina titulo={`Configuracion - Bases AP - ${this.props.match.params.base} Detallle `} regresar={() => { this.props.history.push('/configuracion/basesap') }} />
                <Container>
                    <Row className='mt-2'>
                        <Col xs={12} md={6}>
                            <Form.Control type="text" placeholder="Ingrese valor a buscar" size='sm' />
                        </Col>
                        <Col xs={12} md={2} className={window.outerWidth < 768 ? 'd-grid gap-2 mt-1' : ''}>
                            <Button variant="outline-primary" size='sm'>Buscar</Button>
                        </Col>
                        <Col className="text-end" xs={12} md={4}>
                            <ButtonMUI variant="text" onClick={(event) => { this.AbrirMenu(event) }}>
                                <label className='text-secondary'>Opciones</label>
                                <ExpandMoreIcon color='primary'/>
                            </ButtonMUI>
                            <Menu
                                id="menu-appbar"
                                anchorEl={this.state.objmenu}
                                getContentAnchorEl={null}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                // keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(this.state.objmenu)}
                                onClose={() => { this.CerrarMenu() }}
                            >
                                <MenuItem onClick={() => { }}>Opcion_1</MenuItem>
                                <MenuItem onClick={() => { }}>Opcion_2</MenuItem>
                                <Divider></Divider>
                                <MenuItem onClick={() => { }}>Opcion 3</MenuItem>
                                <MenuItem onClick={() => { }}>Opcion 4</MenuItem>
                                <MenuItem onClick={() => { }}>Opcion 5</MenuItem>
                            </Menu>
                        </Col>
                    </Row>
                    <Row>
                        <div className='mt-1' style={{ height: 500, width: '100%' }}>
                            <DataGrid
                                density='compact'
                                rows={this.state.rows}
                                columns={this.state.columns}
                                pageSize={100}
                                rowsPerPageOptions={[20, 50, 100, 200]}
                                // checkboxSelection
                                localeText={esES.props.MuiDataGrid.localeText}
                            />
                        </div>
                    </Row>
                </Container>


                <Modal
                    show={this.state.mostrarModalCargarArchivos}
                    onHide={() => { this.CerrarModalSubirArchivo() }}
                    size='lg'
                // backdrop="static"
                // keyboard={false}
                // centered
                >
                    <Modal.Header>
                        <Modal.Title>Cargar Bases</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Row>
                                <Col>
                                    <Form.Label className='text-primary'>Selecciona el archivo a cargar</Form.Label>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={10}>
                                    <Form.Group controlId="formFile" className="mb-3">
                                        <Form.Control type="file" size='sm' />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Button variant="outline-primary" size='sm'>Cargar</Button>
                                </Col>
                            </Row>
                            <Row className='mt-2 mb-2'>
                                <Col>
                                    <small className='text-secondary'>Ojo: El sistema verificara el archivo cargado y agregara los registros en base al criterio correspondiente , en caso el valor ya exista sera actualizado para la informacion del ultimo archivo cargado.</small>
                                </Col>
                            </Row>
                            <Row >
                                <Col className="text-center align-items-center">
                                    <Spinner animation="border" variant="primary" />
                                    <Form.Label className='mx-3'>Subiendo Archivo....</Form.Label>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                </Modal>


            </Fragment>
        );
    }
}

export default configBasesAp_Detalle;